// Routes
export const INDEX = 'ROUTE__INDEX';
export const ON_LOAD = 'ROUTE__ON_LOAD';
export const LOGIN = 'ROUTE__LOGIN';
export const LOGOUT = 'ROUTE__LOGOUT';
export const SALESFORCE_CANVAS = 'ROUTE__SALESFORCE_CANVAS';
export const SSO_AUTHENTICATED = 'ROUTE__SSO_AUTHENTICATED';
export const LAUNCH_AS = 'ROUTE__LAUNCH_AS';
export const ONBOARDING = 'ROUTE__ONBOARDING';
export const WELCOME = 'ROUTE__WELCOME';
export const DASHBOARD = 'ROUTE__DASHBOARD';
export const PROGRESS = 'ROUTE__PROGRESS';
export const MANAGER_PROGRESS = 'ROUTE__MANAGER_PROGRESS';
export const PRIVACY = 'ROUTE__PRIVACY';
export const FAQ = 'ROUTE__FAQ';
export const CONTACT = 'ROUTE__CONTACT';
export const FORGOT_USER_ID = 'ROUTE__FORGOT_USER_ID';
export const FORGOT_PASSWORD = 'ROUTE__FORGOT_PASSWORD';
export const RESET_PASSWORD = 'ROUTE__RESET_PASSWORD';
export const ACTIVATION = 'ROUTE__ACTIVATION';
export const PROFILE = 'ROUTE__PROFILE';
export const GOAL_SELECTION = 'ROUTE__GOAL_SELECTION';
export const ERROR = 'ROUTE__ERROR';
export const SSO_GATEWAY_ERROR = 'ROUTE__SSO_GATEWAY_ERROR';
export const SSO_LOGON_ERROR = 'ROUTE__SSO_LOGON_ERROR';
export const PROGRAM_VIEW = 'ROUTE__PROGRAM_VIEW';
export const INVALID_ROUTE = 'ROUTE__NOT_FOUND';

// Router actions
export const ROUTER_LOADED = 'ROUTER_LOADED';
export const ROUTER_LOADING = 'ROUTER_LOADING';
export const ROUTER_COMPONENT_LOADED = 'ROUTER_COMPONENT_LOADED';
export const ROUTER_SET_LANGUAGE_OVERRIDE = 'ROUTER_SET_LANGUAGE_OVERRIDE';
export const ROUTER_SET_SCROLL = 'ROUTER_SET_SCROLL';
export const ROUTER_INITIALIZE = 'ROUTER_INITIALIZE';
